import { apiIsomorphicFetchUserEnvironment } from '#/api/userEnvironment/apiFetchUserEnvironment';
import { idealistRequireAuthentication } from '#/modules/auth/routing/idealist-require-authentication';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import { emailRateRecommendedCandidateRoute } from '#/routing/routes';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { RateRecommendedCandidateLoadable } from './RateRecommendedCandidateLoadable';

export async function loader({
  request,
  context,
}: HorizonAppRouteLoaderArgs<typeof emailRateRecommendedCandidateRoute>) {
  const [{ user }] = await Promise.all([
    apiIsomorphicFetchUserEnvironment({
      request,
      context,
    })(),
    RateRecommendedCandidateLoadable.load(),
  ]);

  if (!user) return idealistRequireAuthentication({ request, context });
}

export default function OrgDashboardRateRecommendedCandidateHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <RateRecommendedCandidateLoadable />;
}
